/* ER Runway (2 nov 2026). Draaiend podium met zeven looks, paneel per look, één pin op de tas. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__erw) return;
    var looks = [].slice.call(root.querySelectorAll('[data-erw-look]'));
    var n = looks.length;
    if (!n) return;
    root.__erw = true;

    var stage = root.querySelector('[data-erw-stage]');
    var sets = [].slice.call(root.querySelectorAll('[data-erw-set]'));
    var ticks = [].slice.call(root.querySelectorAll('[data-erw-tick]'));
    var live = root.querySelector('[data-erw-live]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mq = window.matchMedia('(max-width: 749px)');
    var cur = 0, prevD = looks.map(function () { return null; });
    var inView = false, hover = false, focus = false, pinOpen = false;

    if (!reduce && n > 1) root.classList.add('is-auto');

    function rel(i) {
      var d = i - cur;
      if (d > n / 2) d -= n;
      if (d < -n / 2) d += n;
      return d;
    }

    function layout(animate) {
      var w = stage.clientWidth, m = mq.matches;
      var gap = m ? w * 0.4 : Math.min(w * 0.21, 270);
      var reach = m ? [0, 1, 1.72, 2.3] : [0, 1, 1.8, 2.45];
      var sc = m ? [1, 0.8, 0.66, 0.56] : [1, 0.78, 0.63, 0.53];
      var lift = m ? [0, 0, 0, 0] : [0, -14, -26, -36];
      var blur = [0, 2.5, 5, 7];
      var op = m ? [1, 1, 0.55, 0] : [1, 1, 0.85, 0.5];
      looks.forEach(function (el, i) {
        var d = rel(i), a = Math.min(Math.abs(d), 3), sgn = d < 0 ? -1 : 1;
        var jump = prevD[i] !== null && Math.abs(d - prevD[i]) > n / 2;
        if (jump || !animate) el.style.transition = 'none';
        el.style.setProperty('--x', (sgn * gap * reach[a]).toFixed(1) + 'px');
        el.style.setProperty('--y', lift[a] + 'px');
        el.style.setProperty('--s', sc[a]);
        el.style.setProperty('--b', blur[a] + 'px');
        el.style.setProperty('--o', Math.abs(d) > 3 ? 0 : op[a]);
        el.style.zIndex = String(10 - a);
        el.classList.toggle('is-active', d === 0);
        el.setAttribute('aria-hidden', d === 0 ? 'false' : 'true');
        var b = el.querySelector('[data-erw-pin]');
        if (b) b.tabIndex = d === 0 ? 0 : -1;
        if (jump || !animate) { void el.offsetWidth; el.style.transition = ''; }
        prevD[i] = d;
      });
    }

    function closePins() {
      pinOpen = false;
      root.querySelectorAll('[data-erw-hot].is-open').forEach(function (h) {
        h.classList.remove('is-open');
        var b = h.querySelector('[data-erw-pin]'); if (b) b.setAttribute('aria-expanded', 'false');
        var t = h.querySelector('.erw__tag'); if (t) t.tabIndex = -1;
      });
    }

    function restartBar() {
      var t = ticks[cur];
      if (!t) return;
      var bar = t.querySelector('.erw__bar i');
      if (!bar) return;
      bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = '';
    }

    function go(i, user) {
      cur = ((i % n) + n) % n;
      closePins();
      layout(true);
      sets.forEach(function (s, k) { s.classList.toggle('is-on', k === cur); });
      ticks.forEach(function (t, k) {
        t.classList.toggle('is-on', k === cur);
        var b = t.querySelector('button'); if (b) b.setAttribute('aria-current', k === cur ? 'true' : 'false');
      });
      restartBar();
      if (live && user) live.textContent = (cur + 1) + ' / ' + n + ': ' + (looks[cur].getAttribute('aria-label') || '');
      sync();
    }

    function sync() {
      root.classList.toggle('is-playing', !reduce && inView && !hover && !focus && !pinOpen && !document.hidden);
    }

    /* Autoplay loopt op de voortgangsbalk: als de balk vol is, volgende look. */
    root.addEventListener('animationend', function (e) {
      if (e.animationName === 'erw-fill' && root.classList.contains('is-playing')) go(cur + 1, false);
    });

    /* Bediening */
    var prev = root.querySelector('[data-erw-prev]'), next = root.querySelector('[data-erw-next]');
    if (prev) prev.addEventListener('click', function () { go(cur - 1, true); });
    if (next) next.addEventListener('click', function () { go(cur + 1, true); });
    ticks.forEach(function (t, k) {
      var b = t.querySelector('button');
      if (b) b.addEventListener('click', function () { go(k, true); });
    });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1, true); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1, true); }
      else if (e.key === 'Escape') { closePins(); sync(); }
    });

    /* Swipen en slepen */
    var sx = null, sy = 0, moved = false;
    stage.addEventListener('pointerdown', function (e) {
      if (e.button !== 0 && e.pointerType === 'mouse') return;
      sx = e.clientX; sy = e.clientY; moved = false;
    });
    stage.addEventListener('pointermove', function (e) {
      if (sx === null) return;
      if (Math.abs(e.clientX - sx) > 8 && Math.abs(e.clientX - sx) > Math.abs(e.clientY - sy)) moved = true;
    });
    function endDrag(e) {
      if (sx === null) return;
      var dx = e.clientX - sx;
      sx = null;
      if (moved && Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1), true);
    }
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', function () { sx = null; });

    /* Klik op een look ernaast: naar die look. Klik op de pin: label + tas oplichten in het paneel. */
    stage.addEventListener('click', function (e) {
      if (moved) { moved = false; e.preventDefault(); return; }
      var pin = e.target.closest('[data-erw-pin]');
      if (pin) {
        var hot = pin.closest('[data-erw-hot]');
        var open = !hot.classList.contains('is-open');
        closePins();
        if (open) {
          hot.classList.add('is-open'); pinOpen = true;
          pin.setAttribute('aria-expanded', 'true');
          var tg = hot.querySelector('.erw__tag'); if (tg) tg.tabIndex = 0;
          var worn = sets[cur] && sets[cur].querySelector('[data-erw-worn]');
          if (worn) { worn.classList.remove('is-flash'); void worn.offsetWidth; worn.classList.add('is-flash'); }
        }
        sync();
        return;
      }
      if (e.target.closest('.erw__tag')) return;
      var look = e.target.closest('[data-erw-look]');
      if (look && !look.classList.contains('is-active')) { go(+look.getAttribute('data-i'), true); return; }
      if (pinOpen) { closePins(); sync(); }
    });

    /* Pauze bij hover, focus, buiten beeld of verborgen tab */
    root.addEventListener('mouseenter', function () { hover = true; sync(); });
    root.addEventListener('mouseleave', function () { hover = false; sync(); });
    root.addEventListener('focusin', function () { focus = true; sync(); });
    root.addEventListener('focusout', function () { setTimeout(function () { focus = root.contains(document.activeElement); sync(); }, 0); });
    document.addEventListener('visibilitychange', sync);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { inView = es[0].isIntersecting; sync(); }, { threshold: 0.35 }).observe(root);
    } else { inView = true; }

    var raf = 0;
    window.addEventListener('resize', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { layout(false); });
    });
    if (mq.addEventListener) mq.addEventListener('change', function () { layout(false); });

    layout(false);
    requestAnimationFrame(function () { root.classList.add('is-ready'); sync(); });
  }

  function boot() { document.querySelectorAll('[data-erw]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-erw]'); if (r) init(r); });
})();